import React from "react";
import { useNavigate } from "react-router-dom";

import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewParams, setNewError } from "src/store/gh_market/bundlesSlice";
import { createBundle } from "src/actions/gh_market/bundlesActions";

import Form from "./_partials/_Form";

const New: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const newParams = useAppSelector(state => state.ghMarket.bundles.newParams);
  const error = useAppSelector(state => state.ghMarket.bundles.newError);

  async function handleSave(data: any) {
    const resultAction = await dispatch(createBundle(data));

    if (createBundle.fulfilled.match(resultAction)) {
      dispatch(setNewParams(null));
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={() => dispatch(setNewParams(null))}
      getContainer='.v-layout--body'
    >
      <h6 className="v-content-label">Create Bundle</h6>
      <AlertBlock type='error' message={error} onClose={() => dispatch(setNewError(null))} />
      <Form params={newParams} onFinish={handleSave} />
    </DrawerRight>
  );
}

export default New;
